import ImageLayer from "../ImageLayer";
import { CalendarLayerProps, CalendarProps } from "./interfaces";
import { LayerCustomType, TextCaseType } from "../../interfaces";

export default class CalendarLayer extends ImageLayer {
  protected static customType: LayerCustomType = LayerCustomType.Calendar;
  protected static defaultTypeProps: Partial<CalendarProps> = {
    date: new Date().toISOString().split("T")[0],
    language: "en",
    backgroundColor: "#0000",
    textCase: TextCaseType.None,
    headerAlignment: "center",
    headerColor: "#000",
    dayColor: "#000",
    markerColor: "#f00",
  };

  name: string = "Calendar layer";
  calendarProps: Partial<CalendarProps>;

  constructor(options: Partial<CalendarLayerProps> = {}) {
    const {
      transformSettings = {},
      typeSettings = {},
      ...layerProps
    } = options;
    super();

    this.calendarProps = { ...CalendarLayer.defaultTypeProps, ...typeSettings };

    this.set(transformSettings);
    this.set(layerProps);
  }

  toObject() {
    const object = super.toObject();
    const calendarProps = this.getCalendarProps();
    return { ...object, typeSettings: calendarProps };
  }

  setCalendarProps(props: Partial<CalendarProps>) {
    this.calendarProps = { ...this.calendarProps, ...props };
    this.rerender();
  }

  getCalendarProps(key?: keyof CalendarProps) {
    if (key) {
      return this.calendarProps?.[key];
    } else {
      return { ...this.calendarProps };
    }
  }
}

export * from "./interfaces";
